import { Trans } from '~/common/context';
import { Col, FormFeedback, Row, useConfiguredForm } from '@wyz/ui';
import { get } from 'lodash-es';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { CriteriaField, NewCriteriaSelect } from '~/common/components';
import { ICriteriaAwareForm } from '~/connect/types';
import { TranslationKeys } from '~/common/types';

type Props = React.PropsWithChildren<{
  name?: string;
  disabled?: boolean;
}>;

const CriteriaBuilder = ({ name = 'criteria', disabled, children }: Props) => {
  const configurationContext = useConfiguredForm();

  const methods = useFormContext<ICriteriaAwareForm>();
  const criteriaMethods = useFieldArray({
    name: name as unknown as 'criteria',
    keyName: 'key',
    control: methods.control,
  });
  const addedCriteriaIds = criteriaMethods.fields.map(
    (item) => item.criterion.id,
  );
  const error = get(methods.formState.errors, [name, 'message'], undefined);
  return (
    <>
      <Row>
        <CriteriaField
          associatedCriteriaIds={addedCriteriaIds}
          onRemove={criteriaMethods.remove}
          name={name}
        />

        <Col md={4} xs={12} className='d-flex align-items-end'>
          {configurationContext.mode !== 'READ_ONLY' && (
            <NewCriteriaSelect
              onAdd={(criterion) => {
                criteriaMethods.append({
                  criterion: { id: criterion.id },
                  values: [],
                });
              }}
              criteriaIds={addedCriteriaIds}
              disabled={disabled}
            />
          )}
        </Col>
        <Col sm={12}>
          {error && (
            <FormFeedback invalid id={`${name}.error`}>
              <Trans i18nKey={error as keyof TranslationKeys} />
            </FormFeedback>
          )}
        </Col>
      </Row>
      {children}
    </>
  );
};

export default CriteriaBuilder;
